import deepmerge from 'deepmerge';
import { createTheme } from '@mui/material';
import { cartoThemeOptions } from '@carto/react-ui';

const customTheme = {
  palette: {
    primary: {
      main: '#0054A4',
      light: '#006CD4',
      dark: '#0277BD',
      contrastText: '#fff',
    },
    secondary: {
      main: '#0064D6',
      light: '#0076FC',
      dark: '#0277BD',
      contrastText: '#fff',
    },
    error: {
      main: '#d32f2f',
      light: '#d32f2f',
      dark: '#c62828',
      contrastText: '#fff',
    },
    success: {
      main: '#2e7d32',
      light: '#2e7d32',
      dark: '#1b5e20',
      contrastText: '#fff',
    },
    info: {
      main: '#0288d1',
      light: '#0288d1',
      dark: '#01579b',
      contrastText: '#fff',
    },
    warning: {
      main: '#ef6c00',
      light: '#ef6c00',
      dark: '#c62828',
      contrastText: '#fff',
    },
    qualitative: {
      bold: {
        0: '#edab00',
        1: '#02b1b0',
        2: '#046b99',
        3: '#009bdc',
        4: '#323a45',
        5: '#9fc7da',
        6: '#7F3C8D',
        7: '#11A579',
        8: '#3969AC',
        9: '#F2B701',
        10: '#E73F74',
        11: '#80BA5A',
        12: '#E68310',
        13: '#008695',
        14: '#CF1C90',
        15: '#f97b72',
        16: '#4b4b8f',
        17: '#A5AA99',
      },
    },
  },
  typography: {
    overlineDelicate: {
      fontSize: '10px',
      letterSpacing: '1px',
    },
  },
};

export const cartoTheme = createTheme(deepmerge(cartoThemeOptions, customTheme));

const customDefaultTheme = {
  ...customTheme,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
};

export const defaultTheme = createTheme(customDefaultTheme);
